module.exports = __webpack_public_path__ + "img/award2019.c3c6fb55.png";